module.exports = __webpack_public_path__ + "img/0Q3B5795_Mockup.ce442cc4.jpg";